export default __webpack_public_path__ + "static/media/no_driver.cd8c06b4.png";